<template>
  <section class="spilt-screen-appoitment" :class="{ 'split-section': split }">
    <div class="appointment-summary-container">
      <div v-if="filteredAppointments">
        <appointment-summary-vue
          v-for="appointment in filteredAppointments"
          :key="appointment.id"
          :appointment="appointment"
        />
      </div>
      <div
        v-if="
          loading <= 0 &&
            (!filteredAppointments || filteredAppointments.length === 0)
        "
      >
        <div class="contain-appointment-monthly">
          <div>
            <div class="appoitment-inner-right">
              <span class="appoitment-client-name">Nothing to show</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <transition name="fade">
      <div
        class="loader-container-daily"
        v-if="loading > 0 && filteredAppointments"
      >
        <loader-vue />
      </div>
      <div
        class="loader-container-daily-other"
        v-if="loading > 0 && !filteredAppointments"
      >
        <loader-vue />
      </div>
    </transition>
  </section>
</template>

<script>
import LoaderVue from "../common/Loader.vue";
import AppointmentSummaryVue from "./AppointmentSummary.vue";
import { mapGetters } from "vuex";
import { dateAndTimeMixin } from "../../../mixins/dateAndTimeMixin.js";
import { nameMixin } from "../../../mixins/nameMixin.js";

export default {
  mixins: [dateAndTimeMixin, nameMixin],
  computed: {
    ...mapGetters({
      getAllAppointments: "getAllAppointments",
      getSelectedYear: "getSelectedYear",
      getSelectedMonth: "getSelectedMonth",
      getSelectedDayOfMonth: "getSelectedDayOfMonth",
      selectedProviderID: "getSelectedProviderID",
      searchValue: "getSearchValue",
      loading: "getLoadingGetAppointment",
      userRole: "getUserRole",
      split: "getShowSplitScreenMonthly"
    }),
    /**
     * Returns all the appointments of the current date with proper format and whichever property is required
     */
    appointments() {
      // Step 1: Properly format date
      const date = this.formatDate({
        dayOfMonth: this.getSelectedDayOfMonth,
        month: this.getSelectedMonth,
        year: this.getSelectedYear
      });

      // Step 2: Check if date is in the appointments object which is a key value pair
      // where key is the date and value is an array of appointments on that date
      if (date in this.getAllAppointments) {
        // Step 3: Make and format proper output
        const output = this.getAllAppointments[date].map(appointment => {
          appointment["otherevent_id"] = isNaN(appointment["otherevent_id"])
            ? 0
            : parseInt(appointment["otherevent_id"]);

          appointment.id = isNaN(appointment.id) ? 0 : parseInt(appointment.id);
          // Format title
          let title = "";
          // if (this.userRole === 25) {
          if (this.userRole === 25 && +appointment["otherevent_type"] === 1) {
            title = this.formatName(
              appointment["firstName"],
              appointment["middleName"],
              appointment["lastName"],
              appointment["namePrefix"],
              appointment["nameSuffix"],
              "",
              "clients"
            );
          } else {
            title =
              appointment["otherevent_id"] !== 0
                ? appointment["otherevent_name"]
                : appointment["app_oth_event"] !== ""
                ? appointment["app_oth_event"]
                : this.formatName(
                    appointment["firstName"],
                    appointment["middleName"],
                    appointment["lastName"],
                    appointment["namePrefix"],
                    appointment["nameSuffix"],
                    "",
                    "clients"
                  );
          }

          // Format start time
          const startTime = this.formatTime(
            appointment["app_start_hh"],
            appointment["app_start_mm"],
            appointment["app_start_tt"]
          );

          // Format end time
          const endTime = this.formatTime(
            appointment["app_end_hh"],
            appointment["app_end_mm"],
            appointment["app_end_tt"]
          );

          // Get provider id
          const providerId = isNaN(appointment["provider_id"])
            ? false
            : parseInt(appointment["provider_id"]);

          // Weather appointment has been cancelled
          const cancelled = appointment["is_cancelled"];

          const forProviderId = appointment["forProviderId"];

          return {
            title,
            startTime,
            endTime,
            providerId,
            cancelled,
            id: appointment.id,
            forProviderId
          };
        });
        // Return final result
        return output;
      } else {
        return false;
      }
    },
    /**
     * Function to filter appointments for search
     */
    filteredAppointments() {
      if (this.appointments) {
        if (this.userRole === 22 || this.userRole === 25) {
          return this.appointments.filter(appointment => {
            return (
              appointment.title
                .toLowerCase()
                .search(this.escape(this.searchValue.toLowerCase())) !== -1
            );
          });
        } else {
          return this.appointments.filter(appointment => {
            return (
              appointment.title
                .toLowerCase()
                .search(this.escape(this.searchValue.toLowerCase())) !== -1 &&
              (appointment.forProviderId === this.selectedProviderID || appointment.providerId === this.selectedProviderID)
            );
          });
        }
      } else {
        return false;
      }
    }
  },
  methods: {
    escape(s) {
      // eslint-disable-next-line no-useless-escape
      return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
  },
  components: {
    AppointmentSummaryVue,
    LoaderVue
  }
};
</script>

<style scoped>
.contain-appointment-monthly:first-child {
  margin-top: 10px;
}

.appoitment-inner-right {
  border: none;
}

.loader-container-daily-other {
  width: 100%;
  float: left;
  display: flex;
  justify-content: center;
  margin-bottom: 51px;
}

.loader-container-daily {
  width: 100%;
  float: left;
  display: flex;
  justify-content: center;
  margin-bottom: 51px;
  transform: translateY(-50px);
}

section {
  margin-top: 211px;
  transition: all 0.4s ease-in-out;
}

.split-section {
  margin-top: 430px;
}
</style>
